module.exports = __webpack_public_path__ + "videos/roller-blinds-video.d37d6f0.webm";